
/**
 * Model created for v1 API requests
 */
export class PostRequestPaymentAdapter {
  importe: number;
  fecha_vto: string;
  descripcion: string;
  referencia_externa: string;
  url_redirect: string;
  webhook: string | null;
  qr: boolean;
  id?: number;
  caja_id: number;

  constructor(
    importe: number,
    hostname: string = '',
    description: string = '',
    caja_id: number,
    id?: number | null | undefined,
    installmentsQuantity: number = 1
  ) {
    this.caja_id = caja_id;
    this.fecha_vto = this.makeDueDate();
    this.descripcion =
      description && description.length > 0
        ? description
        : 'PAGO CHECKOUT GENERADO';
    this.referencia_externa = `QR_CAJA`;
    this.url_redirect = `http://${hostname}/home/pos/success`;
    if (id)(
      this.webhook = `http://${hostname}/home/pos/success`
    )
    else(
      this.webhook = null)
    this.importe = Math.floor(importe);
    this.qr = true;
    if (id) {
      this.id = id;
    }
  }

  private makeDueDate(days: number = 4): string {
    const actualDate = new Date();
    actualDate.setDate(actualDate.getDate() + days);
    return actualDate.toISOString().slice(0, 10);
  }
}
